// extracted by mini-css-extract-plugin
export default {"wrapper":"Main_wrapper__J4Jdx"};